const EventCausos = () => import('@/modules/events/views/pages/01-Causos')
const EventSuspense = () => import('@/modules/events/views/pages/02-Suspense')
const EventHumor = () => import('@/modules/events/views/pages/03-Humor')
const EventCarnaval = () => import('@/modules/events/views/pages/04-Carnaval')
const EventAmor = () => import('@/modules/events/views/pages/05-Amor')
const EventFantasia = () => import('@/modules/events/views/pages/06-Fantasia')
const EventFanfic = () => import('@/modules/events/views/pages/07-Fanfic')
const EventPoesia = () => import('@/modules/events/views/pages/08-Poesia')
const EventTerror = () => import('@/modules/events/views/pages/09-Terror')

export default [
  {
    path: '/events/causos',
    name: 'events.show.01-causos',
    component: EventCausos
  },
  {
    path: '/events/suspense',
    name: 'events.show.02-suspense',
    component: EventSuspense
  },
  {
    path: '/events/humor',
    name: 'events.show.03-humor',
    component: EventHumor
  },
  {
    path: '/events/carnaval',
    name: 'events.show.04-carnaval',
    component: EventCarnaval
  },
  {
    path: '/events/amor',
    name: 'events.show.05-amor',
    component: EventAmor
  },
  {
    path: '/events/fantasia',
    name: 'events.show.06-fantasia',
    component: EventFantasia
  },
  {
    path: '/events/fanfics',
    name: 'events.show.07-fanfic',
    component: EventFanfic
  },
  {
    path: '/events/poesia',
    name: 'events.show.08-poesia',
    component: EventPoesia
  },
  {
    path: '/events/terror',
    name: 'events.show.09-terror',
    component: EventTerror
  }
]
